import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import AddModifierButton from './AddModifier';
import DeleteButton from './DeleteButton';
import SidekickModuleSpec from 'src/models/Sidekick/SidekickModuleSpec';
import { selectAnon } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';

type ModuleActionsProps = {
  className?: string;
  disabled: boolean;
  moduleId: string;
  moduleSpec: SidekickModuleSpec;
};

const ModuleActions = ({ className, disabled, moduleSpec, moduleId }: ModuleActionsProps) => {
  const anon = useSelector(selectAnon);

  if (disabled) {
    return null;
  }

  return (
    <ModuleActionsContainer className={className}>
      {!anon && <DeleteButton disabled={disabled} moduleId={moduleId} title="Delete Action" />}

      <AddModifierButton disabled={disabled} moduleId={moduleId} moduleSpec={moduleSpec} />
    </ModuleActionsContainer>
  );
};

export const ModuleActionsContainer = styled.div`
  align-items: center;
  display: flex;
  visibility: hidden;
`;

export default ModuleActions;
